import { render, staticRenderFns } from "./rules-form.vue?vue&type=template&id=6503238e&scoped=true&"
import script from "./rules-form.vue?vue&type=script&lang=ts&"
export * from "./rules-form.vue?vue&type=script&lang=ts&"
import style0 from "./rules-form.vue?vue&type=style&index=0&id=6503238e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6503238e",
  null
  
)

export default component.exports